<template>
    <div v-if="showNotification" class="update-notification">
        <b-alert 
            :variant="alertVariant" 
            :show="showNotification" 
            dismissible
            @dismissed="dismissNotification"
            class="update-alert"
        >
            <div class="d-flex align-items-center">
                <b-icon 
                    :icon="alertIcon" 
                    class="mr-3"
                    :class="alertIconClass"
                ></b-icon>
                <div class="flex-grow-1">
                    <h6 class="mb-1 font-weight-bold">{{ alertTitle }}</h6>
                    <p class="mb-2">{{ updateMessage }}</p>
                    <div v-if="!isForceUpdate" class="d-flex gap-2">
                        <b-button 
                            size="sm" 
                            variant="primary" 
                            @click="reloadNow"
                            class="mr-2"
                        >
                            <b-icon icon="arrow-clockwise" class="mr-1"></b-icon>
                            Обновить сейчас
                        </b-button>
                        <b-button 
                            size="sm" 
                            variant="outline-secondary" 
                            @click="dismissNotification"
                        >
                            Позже
                        </b-button>
                    </div>
                    <div v-else class="d-flex align-items-center">
                        <b-spinner small class="mr-2"></b-spinner>
                        <span class="text-muted">
                            Автоматическая перезагрузка через {{ countdown }} сек.
                        </span>
                    </div>
                </div>
            </div>
        </b-alert>
    </div>
</template>

<script>
import versionService from '@/services/versionService'

export default {
    name: 'UpdateNotification',
    data() {
        return {
            showNotification: false,
            updateMessage: '',
            isForceUpdate: false,
            countdown: 30,
            countdownInterval: null,
            alertVariant: 'info',
            alertIcon: 'info-circle',
            alertIconClass: 'text-info',
            alertTitle: 'Доступно обновление'
        }
    },
    mounted() {
        // Слушаем события от versionService
        if (window.App) {
            window.App.$on('version-update-available', this.handleUpdateAvailable)
        }
    },
    beforeDestroy() {
        // Очищаем слушатели событий
        if (window.App) {
            window.App.$off('version-update-available', this.handleUpdateAvailable)
        }
        this.clearCountdown()
    },
    methods: {
        handleUpdateAvailable(data) {
            this.updateMessage = data.message
            this.isForceUpdate = data.forceUpdate
            
            if (this.isForceUpdate) {
                this.alertVariant = 'danger'
                this.alertIcon = 'exclamation-triangle'
                this.alertIconClass = 'text-danger'
                this.alertTitle = 'Критическое обновление'
                this.startCountdown()
            } else {
                this.alertVariant = 'info'
                this.alertIcon = 'info-circle'
                this.alertIconClass = 'text-info'
                this.alertTitle = 'Доступно обновление'
            }
            
            this.showNotification = true
        },
        
        startCountdown() {
            this.countdown = 30
            this.countdownInterval = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                    this.reloadNow()
                }
            }, 1000)
        },
        
        clearCountdown() {
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval)
                this.countdownInterval = null
            }
        },
        
        reloadNow() {
            this.clearCountdown()
            versionService.reloadPage()
        },
        
        dismissNotification() {
            this.showNotification = false
            this.clearCountdown()
            
            // Показываем уведомление снова через 10 минут
            setTimeout(() => {
                if (!this.isForceUpdate) {
                    this.showNotification = true
                }
            }, 10 * 60 * 1000)
        }
    }
}
</script>

<style scoped>
.update-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
    max-width: 400px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
}

.update-alert {
    border: none;
    border-radius: 8px;
    margin-bottom: 0;
}

.update-alert .alert-dismissible .close {
    padding: 0.75rem 1rem;
}

.gap-2 {
    gap: 0.5rem;
}

@media (max-width: 768px) {
    .update-notification {
        top: 10px;
        right: 10px;
        left: 10px;
        max-width: none;
    }
}
</style>
